import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import {getReadyRecordedFiles, getSimulatorSessionFileId} from 'utils/recording-utils';
import {returnEmptyIfNull} from 'utils/string-utils';
import * as actionTypes from '../constants/public-session-viewer-action-types';
import * as constants from '../constants/public-session-viewer-constants';

import type {List, Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type PublicSessionViewerStore = {
    session: Map<unknown, unknown>;
    markAsViewedTime: number;
    recordingFiles: List<unknown>;
    simulatorSessionFiles: List<unknown>;
    recordingFilesOriginalOrder: List<unknown>;
    simulatorStats: List<unknown>;
    simulatorStatsExist: boolean;
};

const initialState = (): PublicSessionViewerStore => {
    return {
        session: Immutable.Map(),
        markAsViewedTime: constants.SESSION_VIEW_TIMER,
        recordingFiles: Immutable.List(),
        simulatorSessionFiles: Immutable.List(),
        recordingFilesOriginalOrder: Immutable.List(),
        simulatorStats: Immutable.List(),
        simulatorStatsExist: false,
    };
};

const actionsMap: ActionsMap<PublicSessionViewerStore> = {
    [actionTypes.SESSION_SUCCESS]: (state, action) => {
        const session = returnEmptyIfNull(action.data, ['notes']);
        const recordingFiles = getReadyRecordedFiles(session);
        const simulatorSessionFiles = getSimulatorSessionFileId(session);

        return {
            session,
            recordingFiles,
            simulatorSessionFiles,
            recordingFilesOriginalOrder: recordingFiles.map((f) => f), // Required to create a new instance so when modifying the sort the original order is maintained
        };
    },
    [actionTypes.SESSION_FAILURE]: () => {
        return {
            session: null,
        };
    },
    [actionTypes.SESSION_SIMULATOR_STATS_SUCCESS]: (state, action) => {
        return {
            simulatorStats: action.data,
            simulatorStatsExist: true,
        };
    },
    [actionTypes.REORDER_STREAMS]: (state, action) => {
        const max = Math.max(action.sourceIndex, action.targetIndex);
        const min = Math.min(action.sourceIndex, action.targetIndex);
        const swapItemMax = state.recordingFiles.get(max);
        const swapItemMin = state.recordingFiles.get(min);
        let newRecordingList = state.recordingFiles.remove(max);
        newRecordingList = newRecordingList.insert(min, swapItemMax);
        newRecordingList = newRecordingList.remove(min + 1);
        newRecordingList = newRecordingList.insert(max, swapItemMin);

        return {
            recordingFiles: newRecordingList,
        };
    },
    [actionTypes.SESSION_SWITCH]: () => {
        return initialState();
    },
};

export default createReducer<PublicSessionViewerStore>(initialState(), actionsMap);
